import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  variant?: 'default' | 'glass';
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  className = '',
  variant = 'default',
  children,
  ...props
}, ref) => {
  const variants = {
    default: 'bg-card text-card-foreground shadow-sm border border-border/50',
    glass: 'bg-white/80 backdrop-blur-md border border-white/20 shadow-lg'
  };
  return <motion.div ref={ref} className={`rounded-2xl ${variants[variant]} ${className}`} {...props} data-id="element-400">
        {children}
      </motion.div>;
});
Card.displayName = 'Card';